import Modal from 'components/modal'
import { formatDate } from 'utils/helpers'

export interface PowerBiSyncLogDetail {
  _id: string
  recordType?: string
  orderNo: string
  rmaNo?: string
  orderStatus?: string
  eventType?: string
  trigger?: string
  status: string
  responseCode?: string | number
  errorMessage?: string
  syncedAt?: string
  createdAt?: string
  requestPayload?: unknown
  responsePayload?: unknown
}

type Props = {
  isOpen: boolean
  closeModal: React.MouseEventHandler<HTMLSpanElement>
  log?: PowerBiSyncLogDetail
  loading?: boolean
}

const Field = ({
  label,
  value,
}: {
  label: string
  value?: React.ReactNode
}) => (
  <div>
    <p className="text-xs font-bold uppercase tracking-wide text-gray-400">
      {label}
    </p>
    <p className="mt-0.5 text-gray-700">{value || '-'}</p>
  </div>
)

const PowerBiSyncLogDetailModal = ({
  isOpen,
  closeModal,
  log,
  loading,
}: Props) => {
  return (
    <Modal
      isOpen={isOpen}
      closeModal={closeModal}
      title="Power BI Sync Log Details"
      width={720}
    >
      <>
        {loading ? (
          <p className="py-6 text-center text-sm text-gray-400">Loading...</p>
        ) : (
          <div className="max-h-[70vh] w-full overflow-y-auto pr-1">
            <div className="grid grid-cols-2 gap-x-6 gap-y-3 text-sm">
              {/* Rows logged before RMA sync have no type and are all orders */}
              <Field
                label="Type"
                value={log?.recordType === 'RMA' ? 'RMA' : 'Order'}
              />
              <Field label="Order No" value={log?.orderNo} />
              <Field label="RMA No" value={log?.rmaNo} />
              <Field label="Order Status" value={log?.orderStatus} />
              <Field label="Event Type" value={log?.eventType} />
              <Field label="Trigger" value={log?.trigger} />
              <Field label="Status" value={log?.status} />
              <Field label="Response Code" value={log?.responseCode} />
              <Field
                label="Synced At"
                value={
                  log?.syncedAt &&
                  formatDate(log.syncedAt, { includeTime: true })
                }
              />
              <Field
                label="Created At"
                value={
                  log?.createdAt &&
                  formatDate(log.createdAt, { includeTime: true })
                }
              />
              {log?.errorMessage && (
                <div className="col-span-2">
                  <p className="text-xs font-bold uppercase tracking-wide text-gray-400">
                    Error Message
                  </p>
                  <p className="mt-0.5 text-red-600">{log.errorMessage}</p>
                </div>
              )}
            </div>

            <div className="mt-4">
              <p className="py-2.5 text-xs font-bold uppercase tracking-wide text-gray-400">
                Request Payload
              </p>
              <pre className="max-h-64 overflow-auto rounded-lg bg-gray-50 px-4 py-3 text-xs text-gray-500">
                {JSON.stringify(log?.requestPayload ?? {}, null, 2)}
              </pre>
            </div>

            <div className="mt-4">
              <p className="py-2.5 text-xs font-bold uppercase tracking-wide text-gray-400">
                Response Payload
              </p>
              <pre className="max-h-64 overflow-auto rounded-lg bg-gray-50 px-4 py-3 text-xs text-gray-500">
                {JSON.stringify(log?.responsePayload ?? {}, null, 2)}
              </pre>
            </div>
          </div>
        )}
      </>
    </Modal>
  )
}

export default PowerBiSyncLogDetailModal
